export const PORTFOLIO_FIELD_ORDER = [
  'name',
  'type',
  'zone',
  'currency_type',
  'price',
  'price_unit',
  'start_date',
  'end_date',
  'description',
  'image_uploaded'
] as const

export const PORTFOLIO_FIELD_LABELS: Record<string, string> = {
  name: 'Nombre',
  type: 'Tipo',
  zone: 'Zona',
  currency_type: 'Moneda',
  price: 'Precio',
  price_unit: 'Unidad',
  start_date: 'Inicio',
  end_date: 'Fin',
  description: 'Descripción',
  image_uploaded: 'Imagen'
}
